export default __webpack_public_path__ + "static/hero-video-4-2193587861ba54978f41542ad1d59ec2.mp4";